/* 🤖 this file was generated by svg-to-ts */
export const iconStatuswallet: {
  name: 'statuswallet';
  data: string;
} = {
  name: 'statuswallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#5F6CE5" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="M13.3 15.03c-.56 0-1.11.04-1.66.14.45-4.18 3.94-7.35 8.08-7.35 2.54 0 4.28 1.24 4.28 3.82s-2.09 3.82-5.14 3.82c-2.25 0-3.31-.43-5.56-.43m-.16 1.52c-3.05 0-5.14 1.24-5.14 3.82s1.74 3.82 4.28 3.82c4.15 0 7.63-3.17 8.08-7.35-.55.1-1.11.15-1.66.14-2.25 0-3.31-.43-5.56-.43"/></svg>`,
};
